'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteGeneralUi', ['$compile', 'TimeService', 'NotesOverlayContextService', 'NotesQueryManagementService', 'EventStreamsService', '$timeout', '$confirm',
      function($compile, TimeService, NotesOverlayContextService, NotesQueryManagementService, EventStreamsService, $timeout, $confirm) {

      return {
        restrict: 'A',
        template: '<div class="sa-note-general-ui">' +
          '<div class="sa-notes-layout-frame sa-notes-layout-frame-a"></div>' +
          '<div class="sa-notes-layout-frame sa-notes-layout-frame-b"></div>' +
        '</div>',
        scope: {
        },
        controllerAs: 'saNoteGeneralUiCtrl',
        controller: ['$scope', function($scope) {
          var vm = this;
        }],
        link: function (scope, elem) {
          scope.state = {
            currentContext: null,
            frameA: {
              layoutInst: null,
              layoutData: null,
              id: 'a'
            },
            frameB: {
              layoutInst: null,
              layoutData: null,
              id: 'b'
            },
            currentFrame: null,
            blocks: {
              'sa-note-create': {
                confirm: 'You have an unfinished message written. Are you sure you want to proceed? Your unsaved message will be deleted.',
                status: false
              }
            }
          };

          scope.$on('saNoteCreate:noteInProgress', function(event) {
            console.log(event.name);
            scope.state.blocks['sa-note-create'].status = true;
          });

          scope.$on('saNoteCreate:noteEmpty', function(event) {
            console.log(event.name);
            scope.state.blocks['sa-note-create'].status = false;
          });

          function requiresNewPanel(newPanelData) {
            if (lodash.isNull(scope.state.currentFrame)) {
              return true;
            } else {
              return newPanelData.name !== scope.state[scope.state.currentFrame].layoutData.name;
            }
          }

          function getFrameAvailableForRender() {
            if (lodash.isNull(scope.state.currentFrame)) {
              return 'frameA';
            } else {
              if (scope.state.currentFrame === 'frameA') {
                return 'frameB'
              } else {
                return 'frameA';
              }
            }
          }

          function setFrame(frameName, panelData) {
            scope.state[frameName].layoutData = panelData;
          }

          function convertContextToPanel(ctx) {
            if (ctx.obj === 'Home') {
              return {
                name: 'layout-home'
              };
            } else if (ctx.obj === 'Note') {
              return {
                name: 'layout-note',
                data: {
                  id: ctx.id
                }
              };
            } else if (ctx.obj === 'Recent') {
              return {
                name: 'layout-mostrecent'
              };
            } else if (ctx.obj === 'Learn') {
              return {
                name: 'layout-learn'
              };
            } else if (ctx.obj === 'WorkPeriod' && ctx.obj_id) {
              return {
                name: 'layout-workperiod',
                data: {
                  workPeriodId: ctx.obj_id
                }
              };
            } else if (ctx.obj === 'Position' && ctx.obj_id) {
              return {
                name: 'layout-position',
                data: {
                  positionId: ctx.obj_id
                }
              };
            } else if (ctx.obj === 'User' && ctx.obj_id) {
              return {
                name: 'layout-user',
                data: {
                  userId: ctx.obj_id
                }
              };
            } else if (ctx.obj === 'date' && ctx.dates) {
              if (ctx.dates.start.format('MM/DD') === moment(ctx.dates.end).subtract(12, 'hours').format('MM/DD')) {
                return {
                  name: 'layout-date',
                  data: {
                    date: ctx.dates.start
                  }
                };
              } else {
                return {
                  name: 'layout-daterange',
                  data: {
                    start: ctx.dates.start,
                    end: ctx.dates.end
                  }
                };
              }
            } else if (ctx.obj === 'date' && ctx.date) {
              return {
                name: 'layout-date',
                data: {
                  date: ctx.date
                }
              };
            }
          }

          var stream = EventStreamsService.getStream(EventStreamsService.names.notesOverlayContext);

          var sub = stream.filterByType('context').subscribe(function(update) {
            console.log('newContext', update.data, 'currentContext', scope.state.currentContext);
            console.log(requiresNewPanel(convertContextToPanel(update.data)), convertContextToPanel(update.data), getFrameAvailableForRender());

            var blocker = lodash.find(scope.state.blocks, {status: true});

            if (blocker) {
              $confirm({
                text: blocker.confirm,
                ok: 'Proceed',
                cancel: 'Cancel'
              })
                .then(function() {
                  executePanelSwap(update);
                }, function() {
                });
            }

            if (!blocker) {
              executePanelSwap(update);
            }
          });

          function executePanelSwap(update) {
            if (requiresNewPanel(convertContextToPanel(update.data))) {
              var availableFrame = getFrameAvailableForRender();
              setFrame(availableFrame, convertContextToPanel(update.data));
              render(availableFrame);
            } else {
              var x = convertContextToPanel(update.data);
              console.log('$broadcasting sa:saNoteLayout:update', update.data, x);
              setFrame(scope.state.currentFrame, x);
              scope.$broadcast('sa:saNoteLayout:update', {
                payload: x,
                namespace: 'overlay-' + scope.state.currentFrame
              });
              // fire off some kind of update
            }
          }


          scope.$on('$destroy', function() {
            sub.dispose();
            var layoutElems = angular.element(elem).find('.sa-notes-layout-frame .sa-note-layout');

            layoutElems.each(function(i, layoutElem) {
              var oldScope = angular.element(layoutElem).scope();
              oldScope.$broadcast('$destroy');
              layoutElem.remove();
            });
          });

          function render(frameName) {
            var frame = scope.state[frameName];
            var frameElem = $(elem).find('.sa-notes-layout-frame-' + frame.id);

            var html = '<div sa-note-layout="state.' + frameName + '.layoutData" namespace="overlay-' + frameName + '"></div>';
            $(frameElem).html($compile(html)(scope));

            $timeout(function() {
              scope.state.currentFrame = frameName;
              var otherFrames = angular.element(elem).find('.sa-notes-layout-frame.current');
              otherFrames.removeClass('current');
              frameElem.addClass('current in');
              otherFrames.removeClass('in');

              $timeout(function() {
                var layoutElems = otherFrames.find('.sa-note-layout');

                layoutElems.each(function(i, layoutElem) {
                  var oldScope = angular.element(layoutElem).scope();
                  oldScope.$broadcast('$destroy');
                  layoutElem.remove();
                });

              }, 300);
            }, 0);


          }

          var initCtx = NotesOverlayContextService.getContext();

          if (!lodash.isNull(initCtx)) {
            console.log('initialContext', initCtx, convertContextToPanel(initCtx), requiresNewPanel(convertContextToPanel(initCtx)));
            var availableFrame = getFrameAvailableForRender();
            setFrame(availableFrame, convertContextToPanel(initCtx));
            render(availableFrame);
          }

        }
      };
    }]);
